<template>
  <div class="tasks">
    <ActiveTasks
      v-show="this.viewMode === 'active-tasks'"
      :grid-fixed-height="gridFixedHeight"
      :calendar-gaps="calendarGaps"
      @change-view-mode="handleChangeViewMode"
    />
    <ArchivedTasks
      v-show="this.viewMode === 'archived-tasks'"
      @change-view-mode="handleChangeViewMode"
    />
  </div>
</template>

<script>
import ActiveTasks from '../active-tasks';
import ArchivedTasks from '../archived-tasks';

export default {
  props: {
    gridFixedHeight: {
      type: Boolean,
      default: false,
    },
    calendarGaps: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      viewMode: 'active-tasks',
    };
  },
  components: { ActiveTasks, ArchivedTasks },
  methods: {
    handleChangeViewMode(mode) {
      this.viewMode = mode;
    },
  },
};
</script>

<style lang="scss" scoped>
.tasks {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
}
</style>
